import apiTiposClientes from "@/app/services/tiposclientes";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    tipocliente: {
      id: '',
      descricao: ''
    },
    tiposclientes: [],
    busca: "",
    total_itens: 0,
    paginacao: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['descricao'],
      sortDesc: [false]
    }
  },

  mutations: {
    LISTAR(state, tiposclientes) {
      state.tiposclientes = tiposclientes;
    },

    ABRIR(state, tipocliente) {
      state.tipocliente = tipocliente;
    },

    ADICIONAR(state, tipocliente) {
      state.tiposclientes.push(tipocliente);
    },

    ATUALIZAR(state, tipocliente) {
      let index = state.tiposclientes.findIndex(peca_ => peca_.id == tipocliente.id);
      if (index > -1) {
        state.tiposclientes.splice(index, 1, tipocliente);
      }
    },

    EXCLUIR(state, id) {
      let index = state.tiposclientes.findIndex(tipocliente => tipocliente.id == id);
      if (index > -1) {
        state.tiposclientes.splice(index, 1);
      }
    },

    SET_BUSCA(state, busca) {
      state.busca = busca;
    },

    SET_PAGE(state, page) {
      state.paginacao.page = page;
    },

    SET_TOTAL_ITENS(state, total_itens) {
      state.total_itens = total_itens;
    },

    UPDATE_PAGINACAO(state, paginacao) {
      state.paginacao = paginacao;
    },

    ZERAR(state) {
      state.tipocliente = {
        id: '',
        descricao: ''
      };
    }
  },

  actions: {
    async listar({ commit, state }) {
      commit('LOADING_ON', null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.paginacao;

      const paginacao = {
        page, 
        itemsPerPage,
        sortBy: sortBy[0], 
        sortDesc: sortDesc[0]
      }

      if (state.busca) {
        paginacao.busca = state.busca;
      }

      let response = await apiTiposClientes.listar(paginacao);
      commit('LISTAR', response.data);
      commit('SET_TOTAL_ITENS', response.total);
      commit('LOADING_OFF', null, { root: true });
    },

    async abrir({ commit }, id) {
      commit('LOADING_ON', null, { root: true });
      let tipocliente = await apiTiposClientes.abrir(id);
      commit('ABRIR', tipocliente);
      commit('LOADING_OFF', null, { root: true });
    },

    async salvar({ commit }, tipocliente) {
      let novopeca = await apiTiposClientes.salvar(tipocliente);
      commit('ADICIONAR', novopeca);
    },

    async atualizar({ commit }, tipocliente) {
      await apiTiposClientes.atualizar(tipocliente);
      commit('ATUALIZAR', tipocliente);
    },

    async excluir({ commit }, id) {
      await apiTiposClientes.excluir(id);
      commit('EXCLUIR', id);
    },

  }
}
